import React from 'react';
import { Result, Icon } from 'antd';
import msLogo from '../../assets/images/home/ms-blue-logo.svg';
import './../../assets/scss/components/Common/MaintenancePage.scss';

const MaintenancePage = ({ message, subText, startTime, endTime }) => {
    let timeRangeMsg = "";
    if (startTime && endTime) {
        const start = new Date(startTime).toLocaleString();
        const end = new Date(endTime).toLocaleString();
        timeRangeMsg = `<div class="downtime-text">Scheduled downtime: ${start} to ${end}</div>`;
    }

    return (
        <div className="maintenance-page-wrapper">
            <div className="logo-container">
                <img src={msLogo} alt="MillionSpaces" />
            </div>
            <Result
                icon={<Icon type="setting" spin className="maintenance-icon" />}
                title={message || "Down for Maintenance"}
                subTitle={<span dangerouslySetInnerHTML={{ __html: (subText || "We are currently undergoing scheduled maintenance to improve our services. Please check back later.") + timeRangeMsg }} />}
            />
        </div>
    );
};

export default MaintenancePage;
